import { BreadcrumbItems } from './ProfessionalAppointment.types'

export const breadcrumbItems: BreadcrumbItems[] = [
  {
    id: 1,
    label: 'Novo atendimento',
    active: false,
  },
  {
    id: 2,
    label: 'Buscar profissional',
    active: true,
  },
]

export enum WeekChange {
  PrevWeek = -1,
  NextWeek = 1,
}
